/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_Excel_SubtitleInputs */

const en_gc_resources_compare_excel_subtitle = /** @type {(inputs: Gc_Resources_Compare_Excel_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft spreadsheet suite`)
};

const zh_gc_resources_compare_excel_subtitle = /** @type {(inputs: Gc_Resources_Compare_Excel_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`微软电子表格产品`)
};

/**
* | output |
* | --- |
* | "Microsoft spreadsheet suite" |
*
* @param {Gc_Resources_Compare_Excel_SubtitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_excel_subtitle = /** @type {((inputs?: Gc_Resources_Compare_Excel_SubtitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_Excel_SubtitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_excel_subtitle(inputs)
	return zh_gc_resources_compare_excel_subtitle(inputs)
});
export { gc_resources_compare_excel_subtitle as "gc.resources.compare.excel_subtitle" }